import { Component, OnInit } from '@angular/core';
import {UserService} from "../../Services/Users.service";
import {GlobalService} from "../../Services/global.service";
import {Router, ActivatedRoute} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
declare var $;

@Component({
  selector: 'app-isolated-forgot-pwd',
  templateUrl: './isolated-forgot-pwd.component.html',
  styleUrls: ['./isolated-forgot-pwd.component.css']
})
export class IsolatedForgotPwdComponent implements OnInit {

  email_id:string;
  question:string;
  answer:string;
  user_name:string;
  password: string;
  personalStstusCode : string = "";
  alignorStstusCode : string = "";
  byEmailRecovery:boolean = false;
  byUnameRecovery:boolean = true;
  emailValidMsg : string;
  receiver: string;
  email_managedby:boolean = true;
  uname_managedby: string = '';
  color : string;
  securityQuestions : Array<any> = [];
  screenWidth: number = 1366;
  redirectUrl: string = '';
  buttonTitle: any;

  constructor(private userService: UserService, private router : Router, private route: ActivatedRoute, private globalService: GlobalService, private translateService: TranslateService) {
    let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
    this.translateService.reloadLang(lang_name);
    this.translateService.get(['LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
      'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH','LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
      'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
      'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR']).subscribe(label =>{
      this.buttonTitle = label;
    });
  }

  ngOnInit() {
    $("header").css('display','none');
    $("footer").css('display','none');
    $("body").addClass("isolatedBg");
    this.screenWidth = screen.width || window.screen.width;

    window.addEventListener("orientationchange", () => {
      // Announce the new orientation number
      if (window.orientation == 90) {
        this.screenWidth = screen.width || window.screen.width;
      } else {
        this.screenWidth = screen.width || window.screen.width;
      }
    });

    this.route.params.subscribe(params => {
      if(params['url']){
        let id = params['url'];
        if(id && id.includes('http')){
          this.redirectUrl = decodeURIComponent(id);
        }
      }
    });
    let lang_id = this.globalService.getLangId();
    this.translateService.get(['LOGIN_SERVER_MSG.PERSONAL_MSG_SEND_SUCCESS',
      'LOGIN_SERVER_MSG.PERSONAL_MSG_NAME_MAIL_NOT_MATCH','LOGIN_SERVER_MSG.PERSONAL_MSG_MAIL_NOT_MATCH', 'LOGIN_SERVER_MSG.PERSONAL_MSG_NETWORK_ERROR',
      'LOGIN_SERVER_MSG.ALIGNOR_MSG_SEND_SUCCESS', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_USERNAME_NOT_EXSIST', 'LOGIN_SERVER_MSG.ALIGNOR_MSG_QUE_ANS_NOT_MATCH',
      'LOGIN_SERVER_MSG.ALIGNOR_MSG_NETWORK_ERROR']).subscribe(label =>{
      this.buttonTitle = label;
    });
    this.userService.getSecurityQuestions(lang_id)
      .subscribe(questions =>{
        $("#preloader").css('display', 'none');
        if(questions.success){
          this.securityQuestions = questions.data;
          // $("#myModal").modal('show');
        }
      });
  }

  closeModel(mailForm, mailsendAlignorForm){
    mailForm.reset();
    this.question = undefined;
    mailsendAlignorForm.reset();
    this.user_name = "";
    this.password = "";
    this.personalStstusCode = "";
    this.alignorStstusCode = "";
    this.byEmailRecovery = false;
    this.byUnameRecovery = true;
    $('#deafultMail').prop('checked', true);
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      window.close();
    }
  }

  emailOption(e, form){
    form.reset();
    this.byUnameRecovery = true;
    this.byEmailRecovery = false;
    this.email_id = "";
    this.user_name = "";
    this.password = "";
    this.answer = "";
    this.emailValidMsg = '';
    this.alignorStstusCode = '';
    setTimeout(()=>{
      this.receiver = undefined;
      this.question = undefined;
    },100);
  }

  usernameOption(e, form){
    form.reset();
    this.byEmailRecovery = true;
    this.byUnameRecovery = false;
    this.emailValidMsg = '';
    this.email_id = "";
    this.user_name = "";
    this.password = "";
    this.personalStstusCode = "";
    this.answer = "";
    setTimeout(()=>{
      this.receiver = undefined;
      this.question = undefined;
    },100);
  }

  mailsend(mailForm) {
    $("#preloaderModal").css('display','block');

    var mailObj = {
      email_id : this.email_id,
      user_name : this.user_name.toLowerCase(),
      isIsolated: true
    };

    this.userService.sendmaillink(mailObj)
      .subscribe( data =>{
          $("#preloaderModal").css('display','none');
          this.personalStstusCode = data.statusCode;
          if(data.success){
            this.emailValidMsg = data.message;
            this.color = 'green';
            mailForm.reset();

            setTimeout(()=>{
              $('#myModal').modal('hide');
              this.personalStstusCode = "";
              this.receiver = undefined;
              this.question = undefined;
            },1500);
          } else {
            this.emailValidMsg = data.message;
            this.color = 'red';
          }
        }
      );
  }

  clearValidData(){
    this.personalStstusCode = "";
    this.alignorStstusCode = "";

  }

  mailsendAlignor(mailsendAlignorForm){
    let ind = this.securityQuestions.findIndex(obj=> obj.que == this.question);
    if(ind > -1){
      var mailObj = {
        user_name : this.user_name.toLowerCase(),
        question_id : this.securityQuestions[ind].que_id,
        question : this.question,
        answer : this.answer
      };

      this.userService.sendmailAlignorlink(mailObj)
        .subscribe( data =>{
            this.alignorStstusCode = data.statusCode;
            if(data.success){
              if(data.isprivacyprotected){
                this.emailValidMsg = data.message;
                this.color = 'green';
                mailsendAlignorForm.reset();

                setTimeout(()=>{
                  $('#myModal').modal('hide');
                  this.alignorStstusCode = "";
                  this.receiver = undefined;
                  this.question = undefined;
                }, 1500);
              }else{
                this.alignorStstusCode = "";
                $('#myModal').modal('hide');

                if(data.redirect_URL.includes('changePassword/')){
                  let redirecrURL = data.redirect_URL;
                  redirecrURL = redirecrURL.replace('changePassword/','isolatedPWDChange/');
                  if(this.redirectUrl != ''){
                    redirecrURL = redirecrURL + '/' + encodeURIComponent(this.redirectUrl);
                    this.router.navigate([redirecrURL]);
                  }else{
                    this.router.navigate([redirecrURL]);
                  }
                }
              }
            } else {
              this.emailValidMsg = data.message;
              this.color = 'red';
            }
          }
        );
    }
  }

  /*clearValidation(txt){
    this.emailValidMsg = "";
    this.loginStatusCode = "";

    if(txt == 'USERNAME'){
      this.userService.getAllProtectedCommunity()
        .subscribe(comm =>{
          if(comm.success){
            this.AllCommunities = comm.data;
          }
        });
    } else if(txt == 'PASSWORD'){
      this.userService.getSecurityQuestions()
        .subscribe(questions =>{
          if(questions.success){
            this.securityQuestions = questions.data;
          }
        });
    }

    setTimeout(()=>{
      this.receiver = undefined;
      this.question = undefined;
    },100);
  }*/

  ngOnDestroy(){
    $("body").removeClass("isolatedBg");
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/isolated-forgot-pwd/isolated-forgot-pwd.component.ts